import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const DownloadIcon = (props) => (
    <SvgIcon {...props}>
        <path d="M19.4,9.4h-4.2V3H8.8v6.4H4.6l7.4,7.4L19.4,9.4z M4.6,18.9V21h14.8v-2.1H4.6z"/>
    </SvgIcon>
);

export default DownloadIcon;